export const API_BASE_API_SSO_URL = process.env.REACT_APP_REST_API;
export const API_BASE_REPORT_API_URL = `${API_BASE_API_SSO_URL}/tt-custom-report`;
